// Quote Builder — Picker breadcrumb pubsub.
//
// Active picker writes its current breadcrumb chain here; the picker
// area on the right pane renders it above the picker body. Crumbs let
// the user see Configuring | [Supplier] › Category › [Range] and clear
// the configurator back to the empty state.

export interface BreadcrumbCrumb {
  /** Supplier chip (e.g. "TKC") — rendered as a coloured pill. */
  sup?: string;
  /** Plain text label (e.g. "Doors", "Cambridge"). */
  label: string;
}

export interface BreadcrumbState {
  crumbs: BreadcrumbCrumb[];
  /** Whether to show the right-aligned Clear button. */
  canClear: boolean;
}

const EMPTY: BreadcrumbState = { crumbs: [], canClear: false };

let current: BreadcrumbState = EMPTY;
const listeners = new Set<(s: BreadcrumbState) => void>();
let clearHandler: (() => void) | null = null;

export function getBreadcrumb(): BreadcrumbState {
  return current;
}

export function setBreadcrumb(state: BreadcrumbState): void {
  current = state;
  for (const fn of listeners) {
    try { fn(current); } catch { /* swallow */ }
  }
}

export function clearBreadcrumb(): void {
  setBreadcrumb(EMPTY);
  clearHandler = null;
}

export function setBreadcrumbClearHandler(fn: (() => void) | null): void {
  clearHandler = fn;
}

export function invokeBreadcrumbClear(): void {
  if (clearHandler) {
    try { clearHandler(); } catch { /* swallow */ }
  }
}

export function subscribeBreadcrumb(fn: (s: BreadcrumbState) => void): () => void {
  listeners.add(fn);
  return () => { listeners.delete(fn); };
}
